import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const getUserAccount = async () => {
	const url = `/auth/conta`;
	const response = await api.get(url);
	return response.data;
};
export const useGetUserAccount = () => {
	const toast = useToast();
	return useQuery(['getUserAccount'], getUserAccount, {
		onSuccess: () => {},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao atualizar usuário(a).'
			);
			toastErrors?.forEach(element => toast(element));
		},
		refetchOnWindowFocus: false,
	});
};
